import script from "./BlogDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./BlogDetail.vue?vue&type=script&setup=true&lang=js"

import "./BlogDetail.vue?vue&type=style&index=0&id=44e42edb&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-44e42edb"]])

export default __exports__